
const initialState = {
	matter: null,
	fields: null,
	measures: null,
	results_plaintiff: null,
	results_defendant: null,
	results_graphed: null,
	offers_primary: null,
	offers_counter: null,
	user: null,
	token: null,
	tokenExpires: null,
	authChecked: false,
	transient: {
		deleting_from: null,
		deleting_row: null,
		deleting_context: null,
		deleting_offer: null
	},
	toast: {
		text: null,
		kind: null,
		timeout: null
	},
	modal: null
};

const reducer = (state = initialState, action) => {

	switch(action.type) {
		case 'SET_MATTER': 					return reduceSetMatter(state,action);
		case 'SET_MATTER_VALUE': 			return reduceSetMatterValue(state,action);
		case 'TOGGLE_COUNTER_CLAIM': 		return {...state, matter: { ...state.matter, has_counter: !state.matter.has_counter } };
		case 'ADD_ROW': 					return reduceAddRow(state,action);
		case 'TOGGLE_ROW': 					return reduceToggleRow(state,action);
		case 'SHIFT_ROW': 					return reduceShiftRow(state,action);
		case 'PREP_ROW': 					return reducePrepRow(state,action);
		case 'FREE_ROW': 					return reduceFreeRow(state,action);
		case 'DROP_ROW': 					return reduceDropRow(state,action);
		case 'EDIT_LIST_VALUE': 			return reduceEditListValue(state,action);
		case 'EDIT_VALUE': 					return reduceEditValue(state,action);
		case 'EDIT_FIELD': 					return reduceEditField(state,action);
		case 'SAVE_MEASURES_START': 		return {...state, matter: { ...state.matter, measure_saving: true } };
		case 'SET_RESULTS':					return reduceSetResults(state,action);
		case 'ADD_OFFER': 					return reduceAddOffer(state,action);
		case 'EDIT_OFFER': 					return reduceEditOffer(state,action);
		case 'TOGGLE_OFFER': 				return reduceToggleOffer(state,action);
		case 'PREP_OFFER': 					return reducePrepOffer(state,action);
		case 'FREE_OFFER': 					return reduceFreeOffer(state,action);
		case 'DROP_OFFER': 					return reduceDropOffer(state,action);
		case 'SAVE_OFFERS_START': 			return {...state, matter: { ...state.matter, offers_saving: true } };
		case 'SAVE_OFFERS_END': 			return {...state, matter: { ...state.matter, offers_saving: false } };
		case 'SET_AUTH': 					return {...state, token: action.token, tokenExpires: action.expiry};
		case 'CLEAR_MATTER': 				return reduceClearMatter(state,action);
		case 'CLEAR_AUTH': 					return reduceClearAuth(state,action);
		case 'SET_USER': 					return {...state, user: action.user};
		case 'SET_AUTH_CHECKED': 			return {...state, authChecked: action.status};
		case 'SET_MODAL': 					return {...state, modal: action.content};
		case 'SET_TOAST': 					return {...state, toast: {text: action.text, kind: action.kind, timeout: action.timeout} };
		case 'CLEAR_TOAST': 				return reduceClearToast(state,action);
		default: 							return state;
	}

};

const reduceSetMatter = (state,action) => {
	let offers_primary = action.data.offers_primary;
	let offers_counter = action.data.offers_counter;
	// Need to make sure these are empty arrays if they are empty
	if(!offers_primary) offers_primary = [];
	if(!offers_counter) offers_counter = [];
	return {
		...state,
		matter: action.data.matter,
		fields: action.data.fields,
		measures: action.data.measures,
		results_plaintiff: action.data.results_plaintiff,
		results_defendant: action.data.results_defendant,
		results_graphed: action.data.results_graphed,
		offers_primary,
		offers_counter
	};
}



/** ########=======~~~~~~~-------   MATTER VALUE EDITING   -------~~~~~~~========######## **/


const reduceAddRow = (state,action) => {
	const row = state.measures[action.id].length + 1;
	return {
		...state,
		measures: {
			...state.measures,
			[action.id]: [
				...state.measures[action.id],
				{
					id: 'nr'+row,
					description: '',
					value: 0,
					hidden: 0
				}
			]
		}
	};
}

const reduceToggleRow = (state,action) => {
	const row = +action.row;
	const updated_measures = [...state.measures[action.id]];
	const is_hidden = parseInt(updated_measures[row].hidden,10);
	const new_hidden = is_hidden === 0 ? 1 : 0;
	updated_measures[row].hidden = new_hidden;
	return {
		...state,
		measures: {
			...state.measures,
			[action.id]: [...updated_measures]
		}
	};
}

const reduceShiftRow = (state,action) => {
	const updated_measures = [...state.measures[action.id]];

	// Remove and catch the row in question
	const [removed] = updated_measures.splice(action.row,1);
	// Push the removed row into it's new slot
	updated_measures.splice(action.to, 0, removed);

	return {
		...state,
		measures: {
			...state.measures,
			[action.id]: [...updated_measures]
		}
	};
}

const reducePrepRow = (state,action) => {
	const row = +action.row;
	const updated_measures = [...state.measures[action.id]];
	updated_measures[row].deleting = true;

	const new_measures = {
		...state.measures,
		[action.id]: [...updated_measures]
	};

	const clear_id = state.transient.deleting_from;
	const clear_row = +state.transient.deleting_row;

	// If we are already prepping a row for deletion
	if(clear_id) {
		if(clear_id === action.id) {
			updated_measures[clear_row].deleting = false;
		}
		else {
			const alt_measures = [...state.measures[clear_id]];
			alt_measures[clear_row].deleting = false;
			new_measures[clear_id] = [...alt_measures];
		}
	}

	return {
		...state,
		measures: {
			...new_measures
		},
		transient: {
			...state.transient,
			deleting_from: action.id,
			deleting_row: row
		}
	};
}

const reduceFreeRow = (state,action) => {
	const row = +state.transient.deleting_row;
	const id = state.transient.deleting_from;
	const updated_measures = [...state.measures[id]];
	updated_measures[row].deleting = false;
	return {
		...state,
		measures: {
			...state.measures,
			[id]: [...updated_measures]
		},
		transient: {
			...state.transient,
			deleting_from: null,
			deleting_row: null
		}
	};
}

const reduceDropRow = (state,action) => {
	const row = +state.transient.deleting_row;
	const id = state.transient.deleting_from;
	// Need these to be truthy
	if(row >= 0 && id) {
		const updated_measures = [...state.measures[id]];
		updated_measures.splice(row,1);
		return {
			...state,
			measures: {
				...state.measures,
				[id]: [...updated_measures]
			},
			transient: {
				...state.transient,
				deleting_from: null,
				deleting_row: null
			}
		};
	}
	return state;
}

const reduceEditListValue = (state,action) => {
	const row = +action.row;
	const updated_measures = [...state.measures[action.id]];
	updated_measures[row][action.item] = action.value;
	return {
		...state,
		measures: {
			...state.measures,
			[action.id]: [...updated_measures]
		}
	};
}


const reduceEditValue = (state,action) => {
	let new_value = parseInt(action.value,10);
	if(new_value < 0) new_value = 0;
	if(new_value > 100) new_value = 100;
	return {
		...state,
		measures: {
			...state.measures,
			[action.id]: new_value
		}
	};
}

const reduceSetResults = (state,action) => {
	return {
		...state,
		matter: {
			...state.matter,
			measure_saving: false,
			results_loading: false,
			offers_saving: false,
			redirect_from_new: action.data.is_fresh
		},
		results_plaintiff: action.data.plaintiff,
		results_defendant: action.data.defendant,
		results_graphed: action.data.graphed,
	};
}


const reduceSetMatterValue = (state,action) => {
	return {
		...state,
		matter: {
			...state.matter,
			[action.item]: action.value
		}
	};
}


const reduceEditField = (state,action) => {
	const row = +action.row;
	const update_fields = [...state.fields];
	// const update_field = {...fields[row]};
	update_fields[row][action.id] = action.value;
	return {
		...state,
		fields: [...update_fields]
	}
}


/** ########=======~~~~~~~-------   OFFERS EDITING   -------~~~~~~~========######## **/


const reduceAddOffer = (state,action) => {
	const offer_context = 'offers_' + action.context;
	const row = state[offer_context].length + 1;
	return {
		...state,
		[offer_context]: [
			...state[offer_context],
			{
				id: 'nr'+row,
				description: '',
				value: 0,
				hidden: 0
			}
		]
	};
}


const reduceEditOffer = (state,action) => {
	const offer_context = 'offers_' + action.context;
	const row = +action.row;
	const updated_offers = [...state[offer_context]];
	updated_offers[row][action.item] = action.value;
	return {
		...state,
		[offer_context]: updated_offers
	};
}


const reduceToggleOffer = (state,action) => {
	const offer_context = 'offers_' + action.context;
	const row = +action.row;
	const updated_offers = [...state[offer_context]];
	const is_hidden = parseInt(updated_offers[row].hidden,10);
	const new_hidden = is_hidden === 0 ? 1 : 0;
	updated_offers[row].hidden = new_hidden;
	return {
		...state,
		[offer_context]: updated_offers
	};
}

const reducePrepOffer = (state,action) => {
	const offer_context = 'offers_' + action.context;
	const row = +action.row;
	const updated_offers = [...state[offer_context]];

	updated_offers[row].deleting = true;

	const clear_context = state.transient.deleting_context;
	const clear_offer = +state.transient.deleting_offer;

	const new_state = {
		...state,
		[offer_context]: updated_offers,
		transient: {
			...state.transient,
			deleting_context: offer_context,
			deleting_offer: row
		}
	}

	// If we are already prepping a row for deletion
	if(state.transient.deleting_offer !== null) {
		if(offer_context === clear_context) {
			updated_offers[clear_offer].deleting = false;
		}
		else {
			const other_offers = [...state[clear_context]];
			other_offers[clear_offer].deleting = false;
			new_state[clear_context] = other_offers;
		}
	}

	return new_state;
}

const reduceFreeOffer = (state,action) => {
	const row = +state.transient.deleting_offer;
	const context = state.transient.deleting_context;
	const updated_offers = [...state[context]];

	updated_offers[row].deleting = false;

	return {
		...state,
		[context]: updated_offers,
		transient: {
			...state.transient,
			deleting_context: null,
			deleting_offer: null
		}
	};
}

const reduceDropOffer = (state,action) => {
	const row = +state.transient.deleting_offer;
	const context = state.transient.deleting_context;
	// Need these to be truthy
	if(row !== null && context) {
		const updated_offers = [...state[context]];
		updated_offers.splice(row,1);
		return {
			...state,
			[context]: updated_offers,
			transient: {
				...state.transient,
				deleting_context: null,
				deleting_offer: null
			}
		};
	}
	return state;
}



/** ########=======~~~~~~~-------   ACCOUNT MANAGEMENT   -------~~~~~~~========######## **/


const reduceClearMatter = (state,action) => {
	return {
		...state,
		matter: null,
		fields: null,
		measures: null,
		results_plaintiff: null,
		results_defendant: null,
		results_graphed: null,
		offers_primary: null,
		offers_counter: null,
		transient: {
			...state.transient,
			deleting_from: null,
			deleting_row: null,
			deleting_context: null,
			deleting_offer: null
		}
	};
}



const reduceClearAuth = (state,action) => {
	return {
		...state,
		matter: null,
		fields: null,
		measures: null,
		results_plaintiff: null,
		results_defendant: null,
		results_graphed: null,
		offers_primary: null,
		offers_counter: null,
		user: null,
		token: null,
		tokenExpires: null,
		authChecked: true,
		transient: {
			...state.transient,
			deleting_from: null,
			deleting_row: null,
			deleting_context: null,
			deleting_offer: null
		}
	};
}



const reduceClearToast = (state,action) => {
	clearTimeout(state.toast.timeout);
	return {
		...state,
		toast: {
			text: null,
			kind: null,
			timeout: null
		}
	};
}



export default reducer;


// WEBPACK FOOTER //
// ./src/Store/reducer.js